import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="mark-fill">
        <circle cx="50" cy="50" r="3.5" fill="#ffffff" />
      </g>
      <path
        stroke="#ffffff"
        strokeWidth="4.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        d="M50 7C73.748 7 93 26.252 93 50C93 73.748 73.748 93 50 93C26.252 93 7 73.748 7 50C7 26.252 26.252 7 50 7Z"
      />
      <path
        stroke="#ffffff"
        strokeWidth="6.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        d="M33 27V73"
      />
      <path
        stroke="#ffffff"
        strokeWidth="6.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        d="M67 27V73"
      />
      <path
        stroke="#ffffff"
        strokeWidth="5.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        d="M33 46L67 34"
      />
      <path
        stroke="#ffffff"
        strokeWidth="5.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        d="M33 65L67 53"
      />
    </g>
  </svg>
);

export default IconLoader;
